import * as React from 'react';
import { Component, createRef, forwardRef } from 'react';
import styled from 'styled-components/macro';

const StyledButton = styled.a`
  background: none;
  border: none;
  outline: none;
  padding: 0;
  text-decoration: none;
`;

const REPEAT_CLICK_INTERVAL_TIME = 1000;

export class Focusable extends Component {
  focusableRef;
  // Interval which fires "enter" event while mouse is pressed for some time
  repeatClickIntervalId = null;
  constructor(props) {
    super(props);

    this.state = {
      focusPath: props.focusPath || Focusable.generateFocusPath(),
    };
    // Ссылка может быть передана из вне. В таком случае не нужно создавать новую
    this.focusableRef = props.forwardedRef || createRef();
  }

  static generateFocusPath() {
    return `focusable-${Math.random()}`;
  }

  componentDidMount() {
    const ref = (this.props.forwardedRef || this.focusableRef).current;

    if (ref) {
      ref.addEventListener('sn:focused', this.onItemFocus);
      ref.addEventListener('sn:unfocused', this.onItemBlur);
      ref.addEventListener('sn:enter-down', this.onItemEnter);
      ref.addEventListener('sn:navigatefailed', this.onItemNavigateFailed);
      ref.addEventListener('sn:willunfocus', this.onItemWillUnfocus);
    }
  }

  componentWillUnmount() {
    const ref = (this.props.forwardedRef || this.focusableRef).current;

    if (ref) {
      ref.removeEventListener('sn:focused', this.onItemFocus);
      ref.removeEventListener('sn:unfocused', this.onItemBlur);
      ref.removeEventListener('sn:enter-down', this.onItemEnter);
      ref.removeEventListener('sn:navigatefailed', this.onItemNavigateFailed);
      ref.removeEventListener('sn:willunfocus', this.onItemWillUnfocus);
    }
    clearInterval(this.repeatClickIntervalId);
  }

  onItemFocus = () => {
    const { onFocus, index } = this.props;
    const { focusPath } = this.state;
    const { setFocus } = this.context;
    onFocus && onFocus(index);
    setFocus && setFocus(focusPath);
  };

  onItemBlur = () => {
    const { onBlur, index } = this.props;
    onBlur && onBlur(index);
  };

  onItemEnter = (e) => {
    const { onEnter, payload, isFocusableOnClick = false, disabled } = this.props;
    if (e) !isFocusableOnClick && e.preventDefault();
    onEnter && !disabled && onEnter(payload);
  };

  onItemNavigateFailed = (event) => {
    const { onNavigateFailed } = this.props;
    onNavigateFailed && onNavigateFailed(event.detail.direction);
  };

  onItemWillUnfocus = (event) => {
    const { onWillUnfocus } = this.props;
    onWillUnfocus && onWillUnfocus(event.detail.nextSectionId);
  };

  mouseEnter = () => {
    const { focusOnMouseEnter, disabled } = this.props;

    if (focusOnMouseEnter && !disabled) {
      this.focusableRef.current.focus({ preventScroll: true });
    }
  };

  onMouseDown = (e) => {
    this.onItemEnter(e);
    this.repeatClickIntervalId = setInterval(this.onItemEnter, REPEAT_CLICK_INTERVAL_TIME);
  };

  onMouseUp = () => clearInterval(this.repeatClickIntervalId);

  onMouseLeave = () => clearInterval(this.repeatClickIntervalId);

  render() {
    const {
      children,
      className,
      dataTestid,
      disabled,
      id,
      index,
      selected,
      snDown,
      snLeft,
      snRight,
      snUp,
      style,
    } = this.props;

    return (
      <StyledButton
        href={''}
        className={className}
        data-index={index}
        data-nav-item
        data-selected={selected}
        data-sn-down={snDown}
        data-sn-left={snLeft}
        data-sn-right={snRight}
        data-sn-up={snUp}
        data-testid={dataTestid}
        disabled={disabled}
        id={id}
        onMouseEnter={this.mouseEnter}
        onMouseDown={this.onMouseDown}
        onMouseUp={this.onMouseUp}
        onMouseLeave={this.onMouseLeave}
        onClick={(e) => e.preventDefault()}
        ref={this.focusableRef}
        style={style}
        tabindex="-1"
      >
        {children}
      </StyledButton>
    );
  }
}

export default forwardRef((props, ref) => <Focusable forwardedRef={ref} {...props} />);
